import Breadcrumb from './Breadcrumb'

export default Breadcrumb



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/index.js